import React, { useId, useState } from 'react';
import { Phone } from 'lucide-react';
import Modal from 'v3/components/Modal';
import Button from 'v3/components/Button';
import { whatsappContact } from './contract';
import './styles.css';

export default function DriverContact({ driver, companyId }) {
  const titleId = useId();
  const [opened, setOpened] = useState(null);
  const contact = whatsappContact(driver?.phone);
  const scope = JSON.stringify([companyId, driver?.id, driver?.name, driver?.phone]);
  const show = opened === scope;
  const name = driver?.name || 'Motorista não informado';
  return (
    <>
      <button
        type="button"
        className="tc-trip-icon tc-driver-contact"
        disabled={!contact.display}
        title={contact.display ? 'Mostrar telefone do motorista' : 'Telefone não informado'}
        aria-label={
          contact.display ? `Mostrar telefone de ${name}` : `Telefone não informado — ${name}`
        }
        aria-haspopup="dialog"
        onClick={() => setOpened(scope)}
      >
        <Phone size={16} aria-hidden="true" />
      </button>
      {show && (
        <Modal
          show
          centered
          handleClose={() => setOpened(null)}
          className="tc-contact-modal"
          aria-labelledby={titleId}
          heading={<span id={titleId}>Contato do motorista</span>}
          body={
            <div className="tc-contact-body">
              <strong>{name}</strong>
              {contact.href ? (
                <>
                  <a
                    href={contact.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Abrir WhatsApp de ${name}: ${contact.display}`}
                  >
                    {contact.display}
                  </a>
                  <p>Clique no número para abrir o WhatsApp.</p>
                </>
              ) : (
                <>
                  <p>{contact.display}</p>
                  <p role="status">Formato de telefone inválido para abrir o WhatsApp.</p>
                </>
              )}
            </div>
          }
          footer={
            <Button size="sm" variant="secondary" onClick={() => setOpened(null)}>
              Ocultar telefone
            </Button>
          }
        />
      )}
    </>
  );
}

export function KanbanDriverContact({ item, context }) {
  return <DriverContact driver={item.driver} companyId={context.companyId} />;
}
